import { ReactComponent as Playlist } from 'assets/icons/icon-playlist.svg';

export default Playlist;
